module.exports = __webpack_public_path__ + "img/livepen-kid2.342ebbf1.png";